import { Tag, registerPCtor } from "./Tag";

export class P extends Tag {
    public getTagName(): string {
        return "p";
    }
}

registerPCtor(P);
